<template>
  <text-field-like
      label="区分"
      class="operation-types"
      :message="operationTypeHint">
    <v-checkbox
        v-for="processOperationTypeItem in processOperationTypeItems"
        class="mr-6"
        :key="processOperationTypeItem.name"
        v-model="selectedOperationTypes"
        :label="processOperationTypeItem.label"
        :value="processOperationTypeItem.name"
        :disabled="disabled"
        :readonly="readonly"
        hide-details>
      <template #append>
        <el-tooltip
            :content="`個別辞書に${processOperationTypeItem.label}区分のプロセス手順が存在します。`"
            placement="top"
            :open-delay="200">
          <v-icon
              color="green"
              :class="{
                'exists-in-dictionary' : true,
                'exists': processOperations.some(po => po.operationType === processOperationTypeItem.name)
              }"
              small>
            mdi-tooltip-check
          </v-icon>
        </el-tooltip>
      </template>
    </v-checkbox>
  </text-field-like>
</template>

<script>
import { PROCESS_OPERATION_OPERATION_TYPES } from "@/constants";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import deepEquals from "fast-deep-equal";
import {mapActions} from "vuex";
import gql from "graphql-tag";

export default {
  name: 'ProcessOperationTypeSelectForm',
  components: {TextFieldLike},
  model: {
    prop: 'operationTypes',
    event: 'change'
  },
  props: {
    operationTypes: {
      type: Array,
      required: true
    },
    processComponentModelId: {
      type: String,
      required: false
    },
    dataComponentModelId: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      processOperationTypeItems: ['create', 'read', 'update', 'delete'].map(t => ({
        name: t,
        label: PROCESS_OPERATION_OPERATION_TYPES[t],
      })),
      selectedOperationTypes: [],
      processOperationsLoading: false,
      processOperations: []
    }
  },
  created() {
    this.$watch(
        () => [this.processComponentModelId, this.dataComponentModelId],
        () => {
          this.load();
        },
        {immediate: true}
    );
  },
  computed: {
    operationTypeHint() {
      const ot = this.selectedOperationTypes;
      if(this.readonly) {
        return null;
      } else if(ot.length > 0) {
        const serviceTypes = ['利用'];
        if(ot.includes("create")) {
          serviceTypes.push('提供');
        }
        return `関連するデータプロファイル及びサービスプロファイルが「${serviceTypes.join('」「')}」として使用可能になります`;
      } else {
        return '関連するデータプロファイル及びサービスプロファイルを「利用」「提供」のどちらとして使用可能になるかに影響します';
      }
    },
  },
  methods: {
    ...mapActions({
      gqlQuery: 'hds/gqlQuery',
    }),
    async load() {
      if(!this.processComponentModelId || !this.dataComponentModelId) {
        this.processOperations = [];
        return;
      }

      try {
        this.processOperationsLoading = true;
        const {processComponentModel} = await this.gqlQuery({
          query: gql`
              query FindProcessOperations (
                $processComponentModelId: ID!
              ) {
                processComponentModel(processComponentModelId: $processComponentModelId) {
                  processOperations {
                    dataComponentModelId
                    index
                    description
                    operationType
                  }
                }
              }`,
          variables: {
            processComponentModelId: this.processComponentModelId
          }
        });
        this.processOperations = processComponentModel.processOperations
            .filter(po => po.dataComponentModelId === this.dataComponentModelId)
            .sort((a, b) => a.index - b.index);
      } catch (e) {
        console.error(e);
      } finally {
        this.processOperationsLoading = false;
      }
    }
  },
  watch: {
    operationTypes: {
      immediate: true,
      handler(operationTypes) {
        this.selectedOperationTypes = operationTypes.slice().sort();
      }
    },
    selectedOperationTypes: {
      handler(selectedOperationTypes) {
        const operationTypes = selectedOperationTypes.slice().sort();
        if(deepEquals(this.operationTypes, operationTypes)) {
          return;
        }
        this.$emit('change', operationTypes);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-input.operation-types {
  ::v-deep .text-field-like__slot {
    padding-top: 2px;
  }

  ::v-deep .text-field-like__view {
    display: flex;
  }

  .v-input--checkbox {
    padding-top: 4px;
    margin: 0 0.5rem 0 0;
    padding-bottom: 4px;

    ::v-deep .v-label {
      top: 1px;
    }
  }
}

.exists-in-dictionary {
  position: relative;
  top: -5px;
  left: -5px;

  &:not(.exists) {
    visibility: hidden;
  }
}
</style>
